// frontend/src/components/AccessGate.js
// Lightweight shared-passcode gate for the whole web app. Used to keep the
// public domain friends-only on the free Vercel plan (no Password Protection).
//
// IMPORTANT: this is a *soft* gate. The check runs in the browser, so the code
// lives in the JS bundle and a technical visitor could bypass it. It is meant to
// keep casual/random visitors out of a sandbox (play-money) demo - it is NOT a
// security boundary. Real protection still comes from auth + sandbox mode.
//
// Configure by setting REACT_APP_ACCESS_CODE in Vercel (Production scope) and
// redeploying. If the var is unset/empty the gate is inert (local dev, previews).
import React, { useState } from 'react';

const ACCESS_CODE = process.env.REACT_APP_ACCESS_CODE;
const STORAGE_KEY = 'pb_access_granted';

const AccessGate = ({ children }) => {
  const [granted, setGranted] = useState(() => {
    try {
      // Storing the matched code (not just a flag) means rotating the code
      // re-locks everyone automatically.
      return localStorage.getItem(STORAGE_KEY) === ACCESS_CODE;
    } catch {
      return false;
    }
  });
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  // Hooks above always run; gate is inert when no code is configured.
  if (!ACCESS_CODE || granted) {
    return children;
  }

  const submit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (code.trim() === ACCESS_CODE) {
      try {
        localStorage.setItem(STORAGE_KEY, ACCESS_CODE);
      } catch {
        /* private mode / storage disabled - still grant for this session */
      }
      setError('');
      setGranted(true);
    } else {
      setError('Incorrect access code. Please try again.');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#000',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <form
        onSubmit={submit}
        style={{ width: '100%', maxWidth: '380px', textAlign: 'center' }}
      >
        <div
          style={{
            fontSize: '28px',
            fontWeight: 800,
            letterSpacing: '0.5px',
            marginBottom: '8px',
          }}
        >
          Player<span style={{ color: '#3b82f6' }}>Bet</span>
        </div>
        <p style={{ color: '#9ca3af', fontSize: '14px', marginBottom: '28px' }}>
          Private beta — enter your access code to continue
        </p>

        <input
          type="password"
          value={code}
          autoFocus
          onChange={(e) => {
            setCode(e.target.value);
            if (error) setError('');
          }}
          placeholder="Access code"
          style={{
            width: '100%',
            padding: '14px 16px',
            backgroundColor: '#1f2937',
            border: `1px solid ${error ? '#ef4444' : '#374151'}`,
            borderRadius: '10px',
            color: 'white',
            fontSize: '16px',
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />

        {error ? (
          <div style={{ color: '#f87171', fontSize: '13px', marginTop: '10px' }}>
            {error}
          </div>
        ) : null}

        <button
          type="submit"
          style={{
            width: '100%',
            marginTop: '18px',
            padding: '14px',
            backgroundColor: '#2563eb',
            color: 'white',
            fontSize: '16px',
            fontWeight: 600,
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
          }}
        >
          Enter
        </button>
      </form>
    </div>
  );
};

export default AccessGate;
